import { observer } from "mobx-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { AuthenticatorPage } from "./AuthenticatorPage";
import { PublicScope } from "../../auth/models/PublicCredentials";
import { SurveyApi } from "../../survey/services/SurveyApi";
import { MapPage } from "./MapPage";

export const SharedSurveyMapPage = observer(() => {
  const { surveyId } = useParams();
  const [validated, setValidated] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);

  if (validated) return <MapPage isShared />;

  return (
    <AuthenticatorPage
      scope={PublicScope.Survey}
      scopeId={surveyId ?? ""}
      isInvalid={isInvalid}
      onSubmit={() =>
        SurveyApi.validatePassword(surveyId!)
          .then(() => setValidated(true))
          .catch(() => setIsInvalid(true))
      }
    />
  );
});
